export default "__VITE_ASSET__9HHPsKCL__"